module.exports = __webpack_public_path__ + "img/CS-ProfiNew_Overview-Front_3.3262e4a0.jpg";